import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { ArrowLeft, Award, Clipboard, Gift, Link2, Trophy, Users } from 'lucide-react';

export default function ReferEarn() {
  const [data, setData] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    axios.get('/api/customer/referrals').then(r => setData(r.data)).catch(() => {});
    axios.get('/api/customer/referrals/leaderboard').then(r => setLeaderboard(r.data)).catch(() => {});
  }, []);

  const copy = (text) => {
    navigator.clipboard.writeText(text).then(() => toast.success('Copied!')).catch(() => {});
  };

  const refLink = `${window.location.origin}/register?ref=${data?.referralCode}`;
  const referrals = data?.totalReferrals || 0;
  const points = data?.totalPoints || 0;

  return (
    <div className="customer-page referral-page">
      <header className="page-header customer-page-header referral-header">
        <Link to="/home" className="back-btn" aria-label="Back to home"><ArrowLeft size={17} /></Link>
        <div><span className="customer-eyebrow">Rewards programme</span><h1>Refer & Earn</h1><p>Bring friends to D2D and grow your points.</p></div>
        <span className="customer-header-icon"><Gift size={20} /></span>
      </header>

      <main className="referral-content">
        <section className="referral-hero-new">
          <div className="referral-hero-glow" />
          <div className="referral-hero-top"><span className="referral-icon"><Gift size={21} /></span><span className="referral-earn-badge">200 points each</span></div>
          <p className="referral-hero-kicker">Share the D2D advantage</p>
          <h2>Invite a friend.<br /><em>Earn together.</em></h2>
          <p className="referral-hero-copy">Your friend gets a smoother way to ship, and you earn loyalty points when they join through your invite.</p>
          <div className="referral-code-box"><span>Your personal code</span><strong>{data?.referralCode || '—'}</strong></div>
          <div className="referral-actions"><button type="button" className="btn referral-copy-code" onClick={() => copy(data?.referralCode)}><Clipboard size={15} /> Copy code</button><button type="button" className="btn referral-copy-link" onClick={() => copy(refLink)}><Link2 size={15} /> Copy invite link</button></div>
        </section>

        <section className="referral-stats">
          <div><span className="referral-stat-icon"><Users size={16} /></span><strong>{referrals}</strong><small>Friends invited</small></div>
          <div><span className="referral-stat-icon referral-stat-icon--gold"><Award size={16} /></span><strong>{points}</strong><small>Points earned</small></div>
        </section>

        <section className="referral-how card">
          <div className="referral-section-heading"><div><span className="customer-eyebrow">How it works</span><h2>Three simple steps</h2></div><Gift size={19} /></div>
          <div className="referral-steps"><div><b>01</b><span>Share your code or invite link.</span></div><div><b>02</b><span>Your friend creates a D2D account.</span></div><div><b>03</b><span>You both get rewarded.</span></div></div>
        </section>

        {leaderboard.length > 0 && <section className="referral-leaderboard"><div className="referral-section-heading"><div><span className="customer-eyebrow">Community rewards</span><h2>Monthly leaderboard</h2></div><Trophy size={19} /></div><div className="referral-rank-list">{leaderboard.map((u, i) => <div className={`referral-rank-row ${i < 3 ? 'top-rank' : ''}`} key={i}><span className="referral-rank-number">{i < 3 ? <Award size={15} /> : `#${i + 1}`}</span><div><strong>{u.full_name}</strong><small>{u.shipping_mark}</small></div><span className="referral-rank-points"><strong>{u.total_referrals} refs</strong><small>{u.total_points} pts</small></span></div>)}</div></section>}
      </main>
    </div>
  );
}
